import apiSlice from '../api/api.slice';
import {
  IBlogListItem,
  IBlogPost,
  IGetBlogsParams,
  IGetBlogsResponse,
  IGetRelatedBlogsParams,
} from './blog.d';

const blogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET /api/v1/blog?category=&page=&limit= -> { items, hasMore }
    getBlogs: builder.query<IGetBlogsResponse, IGetBlogsParams>({
      query: (params) => ({
        url: '/api/v1/blog',
        method: 'GET',
        params,
      }),
    }),
    // GET /api/v1/blog/:slug -> single post metadata (incl. contentHtmlUrl)
    getBlogBySlug: builder.query<IBlogPost, string>({
      query: (slug) => ({
        url: `/api/v1/blog/${slug}`,
        method: 'GET',
      }),
    }),
    // GET /api/v1/blog/:slug/related?limit= -> { items } (backend-verified envelope)
    getRelatedBlogs: builder.query<IBlogListItem[], IGetRelatedBlogsParams>({
      query: ({ slug, limit }) => ({
        url: `/api/v1/blog/${slug}/related`,
        method: 'GET',
        params: { limit },
      }),
      transformResponse: (
        res: { items?: IBlogListItem[] } | IBlogListItem[]
      ) => (Array.isArray(res) ? res : (res?.items ?? [])),
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['Blog'],
  endpoints: {
    getBlogs: {
      providesTags: ['Blog'],
    },
    getBlogBySlug: {
      providesTags: ['Blog'],
    },
    getRelatedBlogs: {
      providesTags: ['Blog'],
    },
  },
});

export const {
  useGetBlogsQuery,
  useGetBlogBySlugQuery,
  useGetRelatedBlogsQuery,
} = blogApiSlice;
